<template>
  <view-page
    :title="pageTitle"
    permission-name="field_management"
    :edit-button="false"
    :delete-button="false"
    :loading="loading"
    class="management"
    :buttonBack="backButton"
    :backButton="false"
  >
    <template v-slot:leftSide>
      <view-page-data-field
        v-for="field in fields"
        :key="field.label"
        :icon="field.icon"
        :label="field.label"
        :data="field.data"
      />
    </template>
  </view-page>
</template>

<script>
import BackArrowSVG from "@/assets/globals/arrow_back.svg";
import { activitiesTasksDataMixin } from "@/mixins/field/activitiesTasksDataMixin";
import ViewPage from "@/components/Management/ViewPage/ViewPage";
import ViewPageDataField from "@/components/Management/ViewPage/ViewPageDataField";

export default {
  name: "TaskPage",

  components: { ViewPageDataField, ViewPage, BackArrowSVG },

  mixins: [activitiesTasksDataMixin],

  props: {
    task: {
      type: Object
    },
    backButton: {
      type: Function
    }
  },

  data() {
    return {
      loading: false
    };
  },

  computed: {
    pageTitle() {
      let title = this.$i18n.tc("Task", 1);
      if (this.task) {
        if (this.task.hasOwnProperty("title")) {
          title += ": " + this.task.title;
        }
      }
      return title;
    },

    fields() {
      return [
        {
          icon: "label",
          label: this.$i18n.t("Title"),
          data: this.task.title
        },
        {
          icon: "subject",
          label: this.$i18n.t("Description"),
          data: this.task.description
        },
        {
          icon: "assignment_turned_in",
          label: this.$i18n.t("State"),
          data: this.getStateLabel(this.task.state)
        },
        {
          icon: "event",
          label: this.$i18n.t("ScheduledFor"),
          data: this.getFormattedDate(this.task.scheduled_date)
        },
        /*{
          icon: "link",
          label: this.$i18n.tc("Dependency", 2),
          data: this.showDependencies(this.task)
        },*/
        {
          icon: "person",
          label: this.$i18n.tc("Assignee", 1),
          data: this.getUserName(this.task.user_assignee_id)
        } /*,
        {
          icon: "category",
          label: this.$i18n.tc("Type", 1),
          data: this.getTaskTypeLabel(this.task.task_attachment.type)
        }*/
      ];
    }
  }
};
</script>

<style scoped>
.back-arrow-area {
  height: 90px;
  display: flex;
  align-items: center;
}
.back-arrow-button {
  width: 28px;
  height: 28px;
  padding: 6px;
  margin-left: 18px;
  margin-top: 10px;
  border-radius: 100%;
  transition: 0.3s all;
  cursor: pointer;
}
.back-arrow-button:hover {
  background-color: #eaeaea;
}
.back-arrow-icon {
  width: 16px;
  height: 16px;
  fill: var(--primary-highlight);
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Content/Tabs/Activities/TaskDetails.vue